import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const classes = {
  root: css`
    position: relative;
    overflow: hidden;
    min-inline-size: 202px;
    block-size: 104px;
    padding: ${spacing(1.5)};
    border-radius: ${spacing(2)};
    box-sizing: border-box;
    cursor: pointer;
    background-color: ${cssTheme.default.day.backgroundMinor};
  `,
  chevron: css`
    margin-inline-start: ${spacing(-0.5)};
    color: ${cssTheme.default.day.textMinor};
  `,
  icon: css`
    position: absolute;
    inset-block-end: 0;
    inset-inline-end: 0;
  `,
}
